import { useTranslation } from "react-i18next";

const CoverBox = ({ src, alt, ratio = "62%" }) => (
  <div
    className="position-relative rounded-4 shadow overflow-hidden"
    style={{ width: "100%", paddingTop: ratio }} 
  >
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="position-absolute top-0 start-0 w-100 h-100"
      style={{ objectFit: "cover" }}
    />
  </div>
);

const Aboutus = () => {
  const { t } = useTranslation();

  return (
    <main className="about-page">

      <section className="container py-5">
        <div className="row g-4 g-lg-5 align-items-center">
          <div className="col-12 col-md-6 order-1">
            <img
              src="../img/puppy.jpg"
              alt="Shelter dogs"
              loading="lazy"
              className="img-fluid rounded-4 shadow d-block d-md-none"
              style={{ width: "100%", height: "auto" }}
            />
            <div className="d-none d-md-block">
              <CoverBox src="../img/puppy.jpg" alt="Shelter dogs" ratio="62%" />
            </div>
          </div>

          <div className="col-12 col-md-6 order-2">
            <h2 className="h3 fw-semibold mb-3">{t("about.heading-who")}</h2>
            <p className="text-secondary lh-lg mb-3">{t("about.text-1")}</p>
            <p className="text-secondary lh-lg mb-0">{t("about.text-2")}</p>
          </div>
        </div>
      </section>

      <section className="container py-5">
        <div className="row g-4 g-lg-5 align-items-center">
          <div className="col-12 col-md-6 order-2 order-md-1">
            <h2 className="h3 fw-semibold mb-3">{t("about.heading-what")}</h2>
            <p className="text-secondary lh-lg mb-3">{t("about.text-3")}</p>
            <p className="text-secondary lh-lg mb-3">{t("about.text-4")}</p>
            <p className="text-secondary lh-lg mb-0">{t("about.text-5")}</p>
          </div>

          <div className="col-12 col-md-6 order-1 order-md-2">
            <img
              src="../img/shelter.jpg"
              alt={t("about.img-desc")}
              loading="lazy"
              className="img-fluid rounded-4 shadow d-block d-md-none"
              style={{ width: "100%", height: "auto" }}
            />
            <div className="d-none d-md-block">
              <CoverBox src="../img/shelter.jpg" alt={t("about.img-desc")} ratio="62%" />
            </div>
            <p className="small text-center text-secondary mt-2 mb-0">
              {t("about.img-desc")}
            </p>
          </div>
        </div>
      </section>

      <section className="container pb-5">
        <div
          className="p-4 p-md-5 rounded-4 shadow text-center bg-white"
          style={{ maxWidth: 900, margin: "0 auto" }}
        >
          <h3 className="h4 fw-semibold mb-2">{t("about.heading-help")}</h3>
          <p className="text-secondary mb-0">{t("about.text-6")}</p>
        </div>
      </section>
    </main>
  );
};

export default Aboutus;
